export enum Actions {
    MarkReceived = 10,
    TrackPackage = 30,
    MarkRemoteShipped = 40,
    MarkShippedBack = 60
}

export enum AdminActions {
    MarkShipped = 10,
    MarkReceived = 20,
    ShipToRemoteDonor = 30,
    SerologyTestsShippedBack = 40,
    TrackPackage = 50,
    ResultsSent = 60,
    MarkCancelled = 999,
    Delete = 1000,
    Divider = -1
}